var m,r;!function(m){m.medium="medium",m.small="small"}(m||(m={})),function(m){m.primary="primary",m.secondary="secondary"}(r||(r={}));export{r as colorEnum,m as sizeEnum};
//# sourceMappingURL=radio.types.js.map
